(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function initAllHibaInspirationGalleries() {
    var blocks = document.querySelectorAll('[data-hiba-inspiration-block]');

    blocks.forEach(function (block) {
      initHibaInspirationGallery(block);
    });
  }

  function initHibaInspirationGallery(block) {
    if (!block || block.dataset.hibaInspirationReady === 'true') return;

    var track = block.querySelector('[data-hiba-inspiration-track]');
    var prevBtn = block.querySelector('[data-hiba-inspiration-prev]');
    var nextBtn = block.querySelector('[data-hiba-inspiration-next]');
    var openButtons = block.querySelectorAll('[data-hiba-inspiration-open]');
    var lightbox = block.querySelector('[data-hiba-inspiration-lightbox]');
    var lightboxImage = block.querySelector('[data-hiba-inspiration-lightbox-image]');
    var lightboxCloseBtns = block.querySelectorAll('[data-hiba-inspiration-close]');
    var sliderWrap = block.querySelector('[data-hiba-inspiration-wrap]');

    if (!track || !lightbox || !sliderWrap) return;

    block.dataset.hibaInspirationReady = 'true';

    function openLightbox(src, alt) {
      if (!lightboxImage || !src) return;

      lightboxImage.src = src;
      lightboxImage.alt = alt || '';
      lightbox.removeAttribute('hidden');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.setAttribute('hidden', '');
      lightbox.setAttribute('aria-hidden', 'true');

      if (lightboxImage) {
        lightboxImage.src = '';
        lightboxImage.alt = '';
      }

      document.body.style.overflow = '';
    }

    function updateSliderState() {
      var isOverflowing = track.scrollWidth > track.clientWidth + 10;
      var isAtStart = track.scrollLeft < 10;
      var isAtEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;

      sliderWrap.classList.toggle('has-overflow', isOverflowing);
      sliderWrap.classList.toggle('is-at-start', isAtStart);
      sliderWrap.classList.toggle('is-at-end', isAtEnd);

      if (prevBtn) {
        prevBtn.classList.toggle('is-disabled', isAtStart);
        prevBtn.hidden = !isOverflowing;
      }

      if (nextBtn) {
        nextBtn.classList.toggle('is-disabled', isAtEnd);
        nextBtn.hidden = !isOverflowing;
      }
    }

    function scrollSlider(direction) {
      var firstItem = track.querySelector('.hiba-inspiration-block__item');
      var itemWidth = firstItem ? firstItem.offsetWidth : 0;
      var gap = 14;
      var scrollAmount = itemWidth + gap;

      if (direction === 'next') {
        track.scrollLeft += scrollAmount;
      } else {
        track.scrollLeft -= scrollAmount;
      }

      window.setTimeout(updateSliderState, 80);
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        var src = button.getAttribute('data-full-src');
        var alt = button.getAttribute('data-alt') || '';

        openLightbox(src, alt);
      });
    });

    lightboxCloseBtns.forEach(function (button) {
      button.addEventListener('click', closeLightbox);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hasAttribute('hidden')) {
        closeLightbox();
      }
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollSlider('prev');
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollSlider('next');
      });
    }

    track.addEventListener('scroll', updateSliderState, { passive: true });
    window.addEventListener('resize', updateSliderState);

    updateSliderState();
    window.setTimeout(updateSliderState, 300);
    window.setTimeout(updateSliderState, 900);
  }

  function boot() {
    initAllHibaInspirationGalleries();

    window.setTimeout(initAllHibaInspirationGalleries, 250);
    window.setTimeout(initAllHibaInspirationGalleries, 700);
    window.setTimeout(initAllHibaInspirationGalleries, 1400);
  }

  ready(boot);
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();
/* HIBA performance test: remove the CSS-hidden mobile-only media gallery from desktop DOM. */
(function () {
  'use strict';

  function pruneDesktopMobileGallery() {
    if (!window.matchMedia || !window.matchMedia('(min-width: 750px)').matches) return;

    document.querySelectorAll('[data-hiba-mobile-hero-gallery-wrap]').forEach(function (wrap) {
      wrap.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pruneDesktopMobileGallery);
  } else {
    pruneDesktopMobileGallery();
  }

  document.addEventListener('shopify:section:load', pruneDesktopMobileGallery);
})();
